import '../../css/settings/animations.scss';
import { LobbyImage } from '@colonist/types';
import { EnumUtils } from '@colonist/utils';
import { clientI18n } from '../ClientI18n.ts';
import { getLobbyImagePath } from './Utils.ts';
import { UIDeviceController } from '../ui_html/UIDeviceController.ts';
export let translate;
export function initTranslation(translationFunction) {
    translate = translationFunction;
}
function assignBaseElementProps(element, container, className, id) {
    element.className = className;
    element.id = id;
    container.appendChild(element);
}
export function createDiv(className, id) {
    const div = document.createElement('DIV');
    if (className !== undefined) div.className = className;
    if (id !== undefined) div.id = id;
    return div;
}
export function createScriptIn(container, src) {
    const script = document.createElement('script');
    script.src = src;
    assignBaseElementProps(script, container, '', '');
    return script;
}
export function createTRIn(container, id, className = '') {
    const tr = document.createElement('TR');
    assignBaseElementProps(tr, container, className, id);
    return tr;
}
export function createTDIn(container, className = '', text) {
    const td = document.createElement('TD');
    if (text !== undefined) setElementInnerHTML(td, text);
    assignBaseElementProps(td, container, className, '');
    return td;
}
export function createDivIn(container, className, id = '') {
    const div = document.createElement('DIV');
    assignBaseElementProps(div, container, className, id);
    return div;
}
export function createSpanIn(container, className, text) {
    const span = document.createElement('SPAN');
    setElementInnerHTML(span, text);
    assignBaseElementProps(span, container, className, '');
    return span;
}
export function createFormIn(container, className, id = '') {
    const form = document.createElement('FORM');
    assignBaseElementProps(form, container, className, id);
    return form;
}
export function createInputIn(container, className, id = '') {
    const input = document.createElement('INPUT');
    assignBaseElementProps(input, container, className, id);
    return input;
}
export function createTextareaIn(container, className, id = '') {
    const textarea = document.createElement('TEXTAREA');
    assignBaseElementProps(textarea, container, className, id);
    return textarea;
}
export function createSliderIn(container, className, id = '', min, max, step, initialValue) {
    const input = document.createElement('INPUT');
    input.type = 'range';
    input.min = min.toString();
    input.max = max.toString();
    input.step = step.toString();
    input.value = initialValue.toString();
    assignBaseElementProps(input, container, className, id);
    return input;
}
export function createCheckboxIn(container, className, id = '', onclick) {
    const input = createInputIn(container, className, id);
    input.type = 'checkbox';
    // eslint-disable-next-line no-restricted-syntax
    input.onclick = onclick;
    return input;
}
export function createHeaderIn(container, text, className, id = '', hType = 'H3') {
    const header = document.createElement(hType);
    setElementInnerHTML(header, text);
    assignBaseElementProps(header, container, className, id);
    return header;
}
export function createParagraphIn(container, text, className, id = '') {
    const element = document.createElement('P');
    setElementInnerHTML(element, text);
    assignBaseElementProps(element, container, className, id);
    return element;
}
export function createLinkIn(container, href, text, className, id = '', openNewTab = false) {
    const element = document.createElement('A');
    setElementInnerHTML(element, text);
    element.href = href;
    if (openNewTab) element.target = '_blank';
    assignBaseElementProps(element, container, className, id);
    return element;
}
export function createImgIn(container, src, className = '', id = '') {
    const element = document.createElement('IMG');
    setImageElementAlt(element, src);
    element.src = getLobbyImagePath(src);
    assignBaseElementProps(element, container, className, id);
    return element;
}
export function createExternalImgIn(container, src, alt, className = '') {
    const element = document.createElement('IMG');
    element.alt = translate(alt.key, alt.options);
    element.src = src;
    assignBaseElementProps(element, container, className, '');
    return element;
}
export function createOptionIn(container, value, text, defaultSelected = false) {
    const element = document.createElement('OPTION');
    container.appendChild(element);
    element.value = value;
    element.innerText = translate(text.key, text.options);
    element.selected = defaultSelected;
    return element;
}
export function createSelectIn(container, className, id = '', onchange) {
    const element = document.createElement('SELECT');
    element.onchange = ()=>{
        onchange(element.value);
    };
    assignBaseElementProps(element, container, className, id);
    return element;
}
export function updateSelectElement(element, setting) {
    if (element.options[element.selectedIndex].value == setting) return;
    for (const option of Array.from(element.options)){
        if (option.value == setting) {
            option.selected = true;
            break;
        }
    }
}
export function createButtonIn(container, className, text) {
    const button = document.createElement('BUTTON');
    setElementInnerHTML(button, text);
    assignBaseElementProps(button, container, className, '');
    return button;
}
export function createIFrameIn(container, width, height, src, className = '') {
    const iframe = document.createElement('IFRAME');
    iframe.width = width;
    iframe.height = height;
    iframe.src = src;
    iframe.frameBorder = '0';
    assignBaseElementProps(iframe, container, className, '');
    return iframe;
}
export function createListItemIn(container, text, className, id = '') {
    const element = document.createElement('LI');
    setElementInnerHTML(element, text);
    // must be last call to handle fragments
    assignBaseElementProps(element, container, className, id);
    return element;
}
export function createUnorderedListIn(container, className, id = '') {
    const element = document.createElement('UL');
    // must be last call to handle fragments to handle fragments
    assignBaseElementProps(element, container, className, id);
    return element;
}
export function setImageElementAlt(element, src) {
    const altKey = EnumUtils.getEnumKey(src, LobbyImage);
    const altText = {
        key: `strings:imgAlts.${altKey}`
    };
    element.alt = translate(altText.key, altText.options);
}
export function setElementInnerHTML(element, text) {
    var _text_options;
    const isTextAlreadyTranslated = text.key === 'strings:colonistCommon.utils.#buffer';
    const innerHTML = isTextAlreadyTranslated ? (_text_options = text.options) === null || _text_options === void 0 ? void 0 : _text_options.value : translate(text.key, text.options);
    // eslint-disable-next-line no-restricted-syntax
    element.innerHTML = innerHTML;
}
export function setElementInnerText(element, text) {
    var _text_options;
    const isTextAlreadyTranslated = text.key === 'strings:colonistCommon.utils.#buffer';
    const innerText = isTextAlreadyTranslated ? (_text_options = text.options) === null || _text_options === void 0 ? void 0 : _text_options.value : clientI18n.t(text.key, text.options);
    element.innerText = innerText;
}
/**
 * Use this function for nearly all use cases, so that mobile uses touch events
 *
 * Examples of when to use `onclick` or `addEventListener` instead:
 *
 * - To use the event target (or other event properties)
 * - When you want precise control over event handling
 * - When a unique HTML element, like an input, requires a click event to function properly
 * - When attaching a listener to the window or document object
 * - When you want to add multiple listeners to the same element
 */ export function setElementOnClick(element, onClick, preventDefault = false, stopPropagation = false) {
    const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const shouldUseTouchEvents = UIDeviceController.isUserOnMobileWebview() && !UIDeviceController.isCypressTest() && hasTouchSupport;
    if (shouldUseTouchEvents) {
        const MAX_ERROR = 5;
        let startX;
        let startY;
        element.ontouchstart = (event)=>{
            const touch = event.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
        };
        element.ontouchend = async (event)=>{
            const touch = event.changedTouches[0];
            const xDelta = Math.abs(touch.clientX - startX);
            const yDelta = Math.abs(touch.clientY - startY);
            if (xDelta > MAX_ERROR) return;
            if (yDelta > MAX_ERROR) return;
            event.preventDefault();
            if (stopPropagation) event.stopPropagation();
            await onClick(event);
        };
        element.style.transition = 'all 0s';
        return;
    }
    // eslint-disable-next-line no-restricted-syntax
    element.onclick = async (event)=>{
        if (preventDefault) event.preventDefault();
        if (stopPropagation) event.stopPropagation();
        await onClick(event);
    };
}
